import React, { useMemo } from 'react';
import styled from 'styled-components';
import ReactQuill from 'react-quill';

import Text from 'components/common/Text';
import Divider from 'components/Divider';
import { ProductParamInput } from 'containers/ProductRegist/hooks/types';
import Column from 'components/common/Column';
import { sanitizedData } from 'utils/editor';
import { normalizeTableTemporary } from 'utils/editorContent';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;

  img {
    width: 100%;
  }
`;

const EditorValueContainer = styled.div`
  width: 100%;
  padding: 0 24px;

  table {
    * {
      box-sizing: border-box;
    }

    display: table;
    border-collapse: collapse;
    box-sizing: border-box;
    text-indent: initial;
    unicode-bidi: isolate;
    border-spacing: 2px;
    border-color: gray !important;

    &.ql-table-better {
      table-layout: fixed;
    }

    tbody {
      display: table-row-group;
      vertical-align: middle;
      unicode-bidi: isolate;
      border-color: inherit;
      border-width: 1px;
    }

    tr {
      display: table-row;
      vertical-align: inherit;
      unicode-bidi: isolate;
      border-color: inherit;
      border-width: 1px;
      -webkit-border-width: 1px;
      border-width: 1px !important;
    }

    td {
      display: table-cell;
      vertical-align: inherit;
      border: 1px solid #000;
      padding: 2px 5px;
      -webkit-border-width: 1px;
      border-width: 1px !important;

      > p {
        border-color: inherit;
      }
    }
  }

  img {
    width: 100%;
  }
`;

interface IntroduceContainerIProps {
  productParamInput: ProductParamInput;
}

const IntroduceContainer: React.FC<IntroduceContainerIProps> = props => {
  const { productParamInput } = props;

  /*
    quill-table-better 가 표 앞에 두는 <temporary> 줄은 display: none 이라,
    거기에 갇힌 이미지는 재저장 전까지 소개글에서 보이지 않는다.
   */
  const normalizedValue = useMemo(
    () => normalizeTableTemporary(productParamInput.htmlDetailContent),
    [productParamInput.htmlDetailContent],
  );

  return (
    <Container>
      <Text color="#000" size="18px" weight={700} style={{ padding: '0 24px' }}>
        프립 소개
      </Text>

      <EditorValueContainer>
        <div
          dangerouslySetInnerHTML={{
            __html: normalizedValue,
          }}
          // dangerouslySetInnerHTML={sanitizedData(
          //   productParamInput.htmlDetailContent,
          // )}
        />

        {/* <ReactQuill
            readOnly={true}
            theme="bubble"
            style={{ width: '100%' }}
            value={productParamInput.htmlDetailContent}
          /> */}
      </EditorValueContainer>
    </Container>
  );
};

export default IntroduceContainer;
